export default "/_next/static/images/ffd5b46e2749ffbf3e67b286594a5a6b.jpg";